import { BlendState } from './BlendState';
import { RasterizerState } from './RasterizerState';
import { Color4 } from './Color4';
import { Filter } from './Filter';
import { ImageAdjust } from './ImageAdjust';
import { Mask } from './Mask';
import { Matrix3 } from './Matrix3';
import { Vector2 } from './Vector2';

export class BatchStates {
  blends: BlendState[] = [];
  rasterizers: RasterizerState[] = [];
  colors: Color4[] = [];
  effects: number[] = [];
  imageAdjusts: ImageAdjust[] = [];
  masks: Mask[] = [];
  transforms: Matrix3[] = [];
  offsets: Vector2[] = [];
  filters: Filter[] = [];

  blend: BlendState | null = null;
  rasterizer: RasterizerState | null = null;
  color: Color4 = Color4.White;
  effect: number = 0;
  imageAdjust: ImageAdjust | null = null;
  mask1: Mask | null = null;
  mask2: Mask | null = null;
  filter: Filter | null = null;
}
